import React, { Component } from 'react';
import Lottie from "lottie-react";
import noitems from '../../assets/json/noitems.json'
import ls from "local-storage";
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class SuperLikes extends Component {

  constructor(props) {
    super(props);
    this.state = {
      langKey: ls.get('LangValue'),
      api_url: localStorage.getItem('api_url'),
    };
  }

  componentDidMount() {
    if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
      document.body.dir = 'rtl';
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr')
    } else {
      document.body.dir = 'ltr';
      document.body.classList.remove('rtl');
      document.body.classList.add('ltr');
    }
  }

  render() {
    return (
      <>
        {
          (localStorage.getItem('vmsl_page') !== '' && localStorage.getItem('vmsl_page') !== null && localStorage.getItem('vmsl_page') === '1') 
          ? <section className='common_layout'>
            <div className='header_layout'>
              <div className='header_title margin_auto'>
                <h4><Trans i18nKey="Visitors">Visitors</Trans></h4>
              </div>
            </div>
            <div className='superlike_lottie'>
              <div className='superlike_lottie_height'>
                <Lottie animationData={noitems} className='superlike_lottie_player' />
              </div>
              <div className='common_para mt_1'>
                <p><Trans i18nKey="No Visitors">No Visitors</Trans></p>
              </div>
            </div>
          </section> : ''
        }

        {
          (localStorage.getItem('vmsl_page') !== '' && localStorage.getItem('vmsl_page') !== null && localStorage.getItem('vmsl_page') === '2') 
          ? <section className='common_layout'>
            <div className='header_layout'>
              <div className='header_title margin_auto'>
                <h4><Trans i18nKey="Matches">Matches</Trans></h4>
              </div>
            </div>
            <div className='superlike_lottie'>
              <div className='superlike_lottie_height'>
                <Lottie animationData={noitems} className='superlike_lottie_player' />
              </div>
              <div className='common_para mt_1'>
                <p><Trans i18nKey="No Matches">No Matches</Trans></p>
              </div>
            </div>
          </section> : ''
        }

        {
          (localStorage.getItem('vmsl_page') !== '' && localStorage.getItem('vmsl_page') !== null && localStorage.getItem('vmsl_page') === '3') 
          ? <section className='common_layout'>
            <div className='header_layout'>
              <div className='header_title margin_auto'>
                <h4><Trans i18nKey="Super Like">Super Like</Trans></h4>
              </div>
            </div>
            <div className='superlike_lottie'>
              <div className='superlike_lottie_height'>
                <Lottie animationData={noitems} className='superlike_lottie_player' />
              </div>
              <div className='common_para mt_1'>
                <p><Trans i18nKey="No Super Likes">No Super Likes</Trans></p>
              </div>
            </div>
          </section> : ''
        }

        {
          (localStorage.getItem('vmsl_page') !== '' && localStorage.getItem('vmsl_page') !== null && localStorage.getItem('vmsl_page') === '4') 
          ? <section className='common_layout'>
            <div className='header_layout'>
              <div className='header_title margin_auto'>
                <h4><Trans i18nKey="Likes">Likes</Trans></h4>
              </div>
            </div>
            <div className='superlike_lottie'>
              <div className='superlike_lottie_height'>
                <Lottie animationData={noitems} className='superlike_lottie_player' />
              </div>
              <div className='common_para mt_1'>
                <p><Trans i18nKey="No Likes">No Likes</Trans></p>
              </div>
            </div>
          </section> : ''
        }
      </>
    );
  }
}

export default withTranslation("translations")(SuperLikes);
